import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { EoiReadOnlyComponent } from '../eoi-read-only/eoi-read-only.component';
import { environment } from '@/app/environments/environment';
import {
  DomSanitizer,
} from '@angular/platform-browser';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { ChangeDetectorRef } from '@angular/core';
import { CountryService } from '@/app/services/shared/country';

@Component({
  selector: 'app-brief-section',
  standalone: true,
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    MatIcon,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    EoiReadOnlyComponent,
    RichTextEditorComponent,
  ],  templateUrl: './brief-section.component.html',
  styleUrl: './brief-section.component.css'
})
export class BriefSectionComponent implements OnInit {
  eoiData: any;
  mapLink: any;
  google_api_key = environment.apiKey;

  constructor(
    private sanitizer: DomSanitizer,
    private projectsService: ProjectsService,
    private cdr: ChangeDetectorRef,
    private countryService:CountryService
  ){}
  ngOnInit(): void {
    this.preInitiationData();
  }

  getSanitizedHtml(description: string) {
    if (!description) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }

  preInitiationData(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.projectsService.getPreInitiationData().subscribe({
        next: (response: any) => {
          this.eoiData = response.data;
          if (this.eoiData) {
                // set on project brief section
            this.countryService.setProjectCountryName( this.eoiData?.projectDetails?.country?.name )
            const latitude = parseFloat(this.eoiData.projectDetails.latitude);
            const longitude = parseFloat(this.eoiData.projectDetails.longitude);
            
            if (!isNaN(latitude) && !isNaN(longitude)) {
              const url = `https://www.google.com/maps/embed/v1/place?key=${this.google_api_key}&q=${latitude},${longitude}&zoom=12`;
              this.mapLink = this.sanitizer.bypassSecurityTrustResourceUrl(url);
            } else {
              this.mapLink = null;
            }
          }
          this.cdr.detectChanges();
          resolve(); // Resolve the promise when data is successfully processed
        },
        error: (error: any) => {
          console.error('Failed to fetch EOI initiation data:', error);
          reject(error); // Reject the promise in case of an error
        },
      });
    });
  }
  
  

}
